import store from '@/store'

function checkPermission(el, binding) {
  const { value } = binding

  const buttons = store.getters.userInfo.menuPermission.buttons.map(
    (item) => item.name
  )
  if (value && value instanceof Array) {
    // 匹配对应的指令
    const hasPermission = buttons.some((button) => {
      return value.includes(button)
    })

    if (!hasPermission) {
      // el.parentNode && el.parentNode.removeChild(el)
    }
  } else {
    throw new Error('v-permission value is ["admin","editor"]') // 抛出错误
  }
}

export default {
  // 在绑定元素的父组件被挂载后调用
  mounted(el, binding) {
    checkPermission(el, binding)
  },

  // 在包含组件的 VNode 及其子组件的 VNode 更新后调用
  update(el, binding) {
    checkPermission(el, binding)
  }
}
